import React from 'react';

import { Button, Grid, Icon } from 'semantic';
import { useTranslation } from 'react-i18next';
import ThemedSegment from 'components/semantic/Segment';
import { TariffComponent as TariffComponentType } from 'subdomains/cpo/types/charging-policy';
import ConfirmDelete from 'components/ConfirmDelete';
import { PriceAndRestrictionsLabel } from './PriceAndRestrictionsLabel';

type Props = {
  values: TariffComponentType;
  currency: string;
  onEdit?: () => void;
  onRemove?: () => Promise<void> | undefined;
  dragHandleProps?: React.HTMLAttributes<HTMLDivElement>;
};

export const TariffComponentPreview: React.FC<Props> = ({
  values,
  currency,
  onEdit,
  onRemove,
  dragHandleProps,
}) => {
  const { t } = useTranslation();

  return (
    <ThemedSegment offbackground>
      <Grid columns="equal" verticalAlign="middle">
        <Grid.Row>
          <Grid.Column style={{ width: '1rem', flexGrow: 0 }}>
            <div {...dragHandleProps}>
              <Icon size="small" name="arrows-up-down-left-right" />
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <PriceAndRestrictionsLabel
              values={values}
              currency={currency}
              withoutGroupLabel
            />
          </Grid.Column>
          <Grid.Column floated="right" width={2}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {onEdit && (
                <Button icon="edit" basic size="mini" onClick={onEdit} />
              )}
              {onRemove && (
                <ConfirmDelete
                  onConfirm={onRemove}
                  name={t(
                    'tariff.componentPreview.deletePrompt.headerTariffNameText',
                    'the tariff component'
                  )}
                  objectName={t(
                    'tariff.componentPreview.deletePrompt.contentTariffNameText',
                    'tariff component'
                  )}
                  trigger={
                    <Button
                      icon="trash"
                      basic
                      size="mini"
                      onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                        e.preventDefault()
                      }
                    />
                  }
                />
              )}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </ThemedSegment>
  );
};
